import React from "react";
import { useL } from "@/lib/useL";

// One clear sentence for first-time visitors: what SUX1 does, and that typing works too.
export function WelcomeLine() {
  const L = useL();
  return (
    <div className="mt-4 mb-6 max-w-3xl" data-testid="welcome-line">
      <h1 className="text-2xl md:text-3xl font-black tracking-tight leading-tight" style={{ fontFamily: "Outfit" }}>
        {L("Collez ou écrivez un texte : ", "Paste or type a text: ")}
        <span className="text-[#002FA7]">{L("SUX1 en fait un résumé ou une fiche de révision en 5 secondes.", "SUX1 turns it into a summary or a revision sheet in 5 seconds.")}</span>
      </h1>
      <p className="mt-2 text-sm md:text-base text-muted-foreground">
        {L("Un article, une leçon, un chapitre… ou juste une notion à expliquer, par exemple « la photosynthèse ».",
           "An article, a lesson, a chapter… or just a notion to explain, for example \"photosynthesis\".")}
      </p>
    </div>
  );
}
